import Hero from '../components/Hero';
import Features from '../components/Features';

export default function Home() {
    return (
        <>
            <main>
                <Hero />
                <Features />
            </main>
        </>
    );
}
